import api from 'config/axios';
import AppService from 'common/app-service';
import {
  ICreateFinancierPayload,
  IFinancier,
  IFinancierLinkResponse,
  IFinanciersFilters,
  IFinanciersPaginatedResponse,
  IUpdateFinancierPayload,
} from 'common/financier.interface';

export default class FinancierService extends AppService {
  constructor() {
    super('financiers', api);
  }

  async getAll(params?: { page?: number; limit?: number } & IFinanciersFilters): Promise<IFinanciersPaginatedResponse> {
    const response = await this.api.get(this.root(), {
      params: {
        page: params?.page || 1,
        limit: params?.limit || 100,
        ids: params?.ids,
        carrierBranchId: params?.carrierBranchId,
        cnpj: params?.cnpj,
        tradeName: params?.tradeName,
        legalName: params?.legalName,
        sortBy: params?.sortBy,
        sortOrder: params?.sortOrder,
      },
    });

    return response.data;
  }

  async create(payload: ICreateFinancierPayload): Promise<IFinancier> {
    const response = await this.api.post(this.root(), payload);
    return response.data;
  }

  async getById(financierId: number): Promise<IFinancier> {
    const response = await this.api.get(this.root(financierId));
    return response.data;
  }

  async linkCarrierRoot(financierId: number, carrierRootId: number): Promise<IFinancierLinkResponse> {
    const response = await this.api.post(`${this.root(financierId)}/carrier-roots/${carrierRootId}`);
    return response.data;
  }

  async unlinkCarrierRoot(financierId: number, carrierRootId: number): Promise<IFinancierLinkResponse> {
    const response = await this.api.delete(`${this.root(financierId)}/carrier-roots/${carrierRootId}`);
    return response.data;
  }

  async update(financierId: number, payload: IUpdateFinancierPayload): Promise<IFinancier> {
    const response = await this.api.put(this.root(financierId), payload);
    return response.data;
  }
}
